module.exports = __webpack_public_path__ + "img/12.a8417292.jpg";